import { dateFormat } from "../../const/date";
import sanitizeHtml from "sanitize-html";

type BlogData = {
  data: {
    category: Array<string>;
    title: Array<string>;
    link: Array<string>;
    description: Array<string>;
    pubDate: Array<string>;
  }[];
};

const Blog = ({ data }: { data: BlogData[] | any[] }) => {
  const blog = ParseData({ data });

  const getTranslated = (key: string) => {
    const text = key || ""; //data json에서 호출
    const sanitizedText = sanitizeHtml(text, {
      allowedTags: ["br", "em", "span"], //허용할 태그 지정
    });
    return { __html: sanitizedText };
  };
  return (
    <div
      id="blog"
      className="relative w-full h-full max-w-[1600px] px-2 mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div id="title" className="relative w-full h-fit mb-5 xl:mb-10 gmedium">
        <div className=" flex justify-start items-end gap-2 lg:gap-3">
          <div className=" relative w-fit h-fit">
            <img
              alt="logo"
              className="!relative w-auto h-full max-h-10 lg:max-h-24 py-1 object-contain cursor-pointer"
              src="/images/logo.png"
              width={531}
              height={65}
            />
          </div>
          <h2 className="leading-none">
            <span className="text-[#00bf19]">BLOG</span>&nbsp;작업사례
          </h2>
        </div>
        <div className="relative w-full h-fit max-w-[1400px] mx-auto">
          <p className="lg:text-xl mb-5 lg:mb-0">
            다양한 현장들을 한번에! 한눈에! 확인하실 수 있는 24시긴급출동누수
            블로그 작업사례!
          </p>
        </div>
      </div>
      <div className="relative w-full h-fit max-w-[1400px] mx-auto grid grid-cols-2 lg:grid-cols-3 lg:grid-rows-3 gap-3 lg:gap-5 gmedium">
        {blog.map((v, i) => (
          <div
            key={i}
            onClick={() => window.open(v.link[0])}
            className={
              i > 7
                ? "hidden lg:block relative w-full h-full"
                : "relative w-full h-full"
            }
          >
            <div className="relative w-full h-full grid bg-white p-2 md:p-3 rounded-3xl text-left border cursor-pointer transition-all duration-300 overflow-hidden">
              <p
                className={`relative w-full whitespace-nowrap overflow-hidden overflow-ellipsis lg:text-lg h-fit mb-1 lg:mb-2`}
              >
                {v.title[0]}
              </p>
              <small
                className={`relative w-full whitespace-nowrap md:whitespace-normal overflow-hidden overflow-ellipsis h-fit md:h-9 my-2 lg:my-0 break-words md:line-clamp-2 text-sm opacity-60`}
                dangerouslySetInnerHTML={getTranslated(v.description[0])}
                // dangerouslySetInnerHTML={{ __html: v.description[0] }}
              ></small>
              <div className="md:pt-2 lg:mt-3 3xl:mt-4 lg:flex justify-between items-end">
                <small className="hidden xl:block opacity-40 lg:text-sm">
                  {dateFormat(v.pubDate[0])}
                </small>
                <small className="text-main lg:text-sm">{v.category[0]}</small>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;

const parseString = require("xml2js").parseString;

const ParseData = ({ data }: { data: any[] }) => {
  const dataArr: {
    title: any;
    link: any;
    description: any;
    pubDate: any;
    category: any;
  }[] = [];

  parseString(data, (err: any, result: any) => {
    if (err) {
      console.error("XML 파싱 에러:", err);
      return;
    }

    const items = result?.rss?.channel?.[0]?.item;
    if (Array.isArray(items)) {
      items.slice(0, 9).forEach((v: any) => {
        dataArr.push({
          title: v.title,
          link: v.link,
          description: v.description,
          pubDate: v.pubDate,
          category: v.category,
        });
      });
    } else {
      console.warn("item 배열이 없습니다.");
    }
  });

  return dataArr;
};
